<template>
  <v-container>
    <RegisteredSpectator />
  </v-container>
</template>

<script>
import RegisteredSpectator from "@/views/events/registration/RegisteredSpectator.vue";

export default {
    components: {
        RegisteredSpectator
    }
};
</script>